import React, { useEffect, useState } from 'react';
import { getData } from '../../../../services/apiService';
import ResultTable from './ResultTable';
import SummaryCards from './SummaryCards';
import { useSelector } from 'react-redux';

const ExamResultTable = () => {
  const [resultData, setResultData] = useState({});
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.user.user);
  const rollNo = user?.roll_no || null;
  useEffect(() => {
    const fetchResult = async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await getData(`/HallTicket/GetStudentResult?rollNo=${rollNo}`);

        if (response?.isError === false && response?.result) {
          setResultData(response.result);
        } else {
          setError(response?.message || 'No data received');
        }
      } catch (error) {
        console.error('Error fetching results:', error);
        setError(error.message || 'An error occurred while fetching results');
      } finally {
        setLoading(false);
      }
    };

    fetchResult();
  }, [rollNo]);

  // Get ALL results data (all semesters) - sorted by semester
  const allResults = resultData?.resultsData || [];

  // Get all arrears (subjects with isArrear = true)
  const arrearResults = allResults.filter(
    subject => subject.isArrear === true
  );

  if (loading) {
    return (
      <div className="mx-auto p-4">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-300 rounded w-1/2 mb-6 mx-auto"></div>
          <div className="h-64 bg-gray-200 rounded-lg mb-6"></div>
          <div className="h-32 bg-gray-200 rounded-lg mb-6"></div>
          <div className="grid grid-cols-2 gap-4">
            <div className="h-48 bg-gray-200 rounded-lg"></div>
            <div className="h-48 bg-gray-200 rounded-lg"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mx-auto p-4 text-center">
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4">
          <p className="font-bold">Error</p>
          <p>{error}</p>
        </div>
        <button
          onClick={() => window.location.reload()}
          className="bg-gradient-to-r from-[#0d4f5c] to-[#1a7a8a] hover:from-[#1a7a8a] hover:to-[#0d4f5c] text-white font-bold py-2 px-4 rounded transition-all duration-300"
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="mx-auto p-4">
      <h2 className="text-2xl font-bold text-center mb-2 text-[#0d4f5c]">
        Complete Examination Results
      </h2>
      <p className="text-center text-gray-600 mb-4">
        All Semester Results with Arrear/Backlog Subjects
      </p>

      <ResultTable
        allResults={allResults}
        arrearResults={arrearResults}
      />

      <GradingSystem />

      <SummaryCards
        semesterSummaries={resultData?.semesterSummary || []}
        cumulativeSummary={resultData?.cumulativeSummary}
      />
    </div>
  );
};

// Grading System Component
const GradingSystem = () => {
  const grades = [
    { grade: 'A+', range: '90-100%', color: 'bg-green-600' },
    { grade: 'A', range: '80-89%', color: 'bg-green-500' },
    { grade: 'A-', range: '70-79%', color: 'bg-green-400' },
    { grade: 'B+', range: '60-69%', color: 'bg-blue-500' },
    { grade: 'B', range: '50-59%', color: 'bg-blue-400' },
    { grade: 'C', range: '40-49%', color: 'bg-yellow-500' },
    { grade: 'D', range: '30-39%', color: 'bg-orange-500' },
    { grade: 'F', range: 'Below 30%', color: 'bg-red-600' },
  ];

  return (
    <div className="my-6 p-4 bg-gradient-to-r from-[#0d4f5c] to-[#1a7a8a] rounded-lg shadow-lg">
      <h3 className="text-lg font-medium text-white mb-3">Grading System Reference</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
        {grades.map((item, index) => (
          <div key={index} className="flex items-center p-2 bg-white rounded shadow-sm">
            <span className={`w-8 h-8 rounded-full mr-3 flex items-center justify-center text-white ${item.color}`}>
              {item.grade}
            </span>
            <span>{item.range}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExamResultTable;